/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {PropsWithChildren} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import {BulkActionEntity} from '@ion/core/src/types/entities';
import {useEditorStyles} from '@ion/dls/src/hooks/useEditorStyles';
import {dlsAlt, dlsColor} from '@ion/dls/src/theme/theme';
import {HeaderTypography} from '@ion/dls/src/typography/HeaderTypography';

export interface StepProps {
  showSelectionChips?: boolean;
  entity: BulkActionEntity;
  header: string;
}

export const useStyles = makeStyles(() => ({
  container : {
    display       : 'flex',
    flex          : '1',
    flexDirection : 'column'
  },
  containerHeader : {
    display        : 'flex',
    justifyContent : 'space-between',
    alignItems     : 'center'
  },
  subtitle : {
    ...dlsAlt('typography', 'label2'),
    color         : dlsColor('aaBlue'),
    letterSpacing : '0px',
    position      : 'relative',
    bottom        : 0
  },
  subtitleOffset : {
    top   : '20px',
    float : 'right'
  },
  asterisk : {
    color  : dlsColor('aaBlue'),
    margin : '0 2px'
  },
  step : {
    display       : 'flex',
    flexDirection : 'column',
    flex          : '10',
    minHeight     : '0'
  },
  actionContainer : {
    display   : 'flex',
    flex      : '1',
    minHeight : '0'
  },
  activityNameContainer : {
    padding : '10px 0',
    display : 'flex'
  },
  stepHeader : {
    marginBottom : '10px',
    display      : 'flex'
  }
}));

/**
 * Step container containining common step styling to provide a consistent & smooth user experience.
 */
export const Step = ({
  children,
  header
}: PropsWithChildren<StepProps>) => {
  const {classes}    = useEditorStyles();
  const localClasses = useStyles();
  return (
    <div className={classnames(classes.formWrapper, localClasses.step)}>
      <div className={localClasses.stepHeader}>
        <HeaderTypography variant='h4'>
          {header}
        </HeaderTypography>
      </div>
      {children}
    </div>
  );
};

export default Step;
